import { mdiNoteMultipleOutline } from '@mdi/js'

export default {
  title: 'Bank Question',
  to: 'bank-hod',
  icon: mdiNoteMultipleOutline,
  resource: 'BankQuestionHeadDepartment',
  action: 'read',
}
